<template>
  <div id="footer" class="container-fluid">
    <div class="logo">
      <img style="object-fit: contain;" src="@/assets/img/logo_black.png" alt="logo图">
    </div>
    <p class="title">苏州术行信息科技有限公司</p>
    <p class="address_tel_fax">
      <span>地址：苏州工业园区唯新路168号8号楼309室 </span>
      <span>Tel：18168954518</span>
    </p>
    <p class="email_wx">
      <span>邮箱：18168954518@163.com</span>
      <span>微信号：18168954518</span>
    </p>
    <p class="terms">
      <a href="/">首页</a>
      <em> |</em>
      <a href="/">关于我们</a>
      <em> |</em>
      <a href="/">隐私协议</a>
      <em> |</em>
      <a href="/">使用条款</a>
    </p>
    <p class="copy">
    <a href="https://beian.miit.gov.cn/" target="_blank" class="copyright-item">苏ICP备2023043340号</a>
    <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=" target="_blank"><img style="margin:0 4px;" src="@/assets/img/beian.png" alt="">公网安备
                </a></p>
    <p class="copy">Copyright &copy; 2019 - {{ new Date().getFullYear() }} 苏州术行信息科技有限公司</p>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  overflow: hidden;
  text-align: center;
}
.logo {
  width: 95px;
  height: 45px;
  margin: 50px auto 20px;
}
.title {
  font-size: 25px;
  margin-bottom: 20px;
}
.address_tel_fax {
  color: #d3d3d3;
  font-size: 14px;
  margin: 10px 0;
}
.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}
.terms {
  color: #d3d3d3;
  font-size: 14px;
}
.terms a {
  color: #d3d3d3;
  font-size: 14px;
}
.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 0px 0 10px;
}
.copy a {
  color: #d3d3d3;
  font-size: 14px;
  display: inline;
}
.copy a img {
  display: inline;
}
@media screen and (max-width: 997px) {
  .title {
    font-size: 20px;
  }
  .address_tel_fax {
    font-size: 12px;
  }
  .email_wx {

  font-size: 12px;
}
.copy {
  font-size: 12px;
  margin: 30px 0 10px;
}
}
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue